import { render, staticRenderFns } from "./ntp.vue?vue&type=template&id=215c296a&"
import script from "./ntp.vue?vue&type=script&lang=js&"
export * from "./ntp.vue?vue&type=script&lang=js&"
import style0 from "./ntp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports